import { ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

export const BagButton = () => {
  const { count, setIsOpen } = useCart();
  return (
    <button
      onClick={() => setIsOpen(true)}
      className="relative text-ash hover:text-gold transition-colors duration-500"
      data-testid="bag-open-button"
      aria-label="Open your bag"
    >
      <ShoppingBag className="h-5 w-5" />
      {count > 0 && (
        <span
          className="absolute -top-2 -right-2 h-4 w-4 rounded-full bg-gold text-ink text-[10px] font-semibold flex items-center justify-center"
          data-testid="bag-count-badge"
        >
          {count}
        </span>
      )}
    </button>
  );
};
